module.exports = __webpack_public_path__ + "img/cooperate_zf_03@2x.1e618c8d.png";